import React, { type FC, useEffect } from 'react'

import { InputLabel, MenuItem, Select } from '@mui/material'
import { StyledFormControl } from './Filters.style'
import { FetchCompaniesAction } from '../../../redux/admin/admin-companies-actions'
import { SetMeterActivePageAction } from '../../../redux/meter-table/meter-table-actions'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { type AdminCompany } from '../../../redux/admin/admin-companies-types'
import { CustomerFilterChangedAction } from '../../../redux/data/data-actions'
import { type CustomerFilter, CustomerFilterType } from '../../../redux/data/data-types'

/**
 * Filter for selecting customer company.
 */
export const CustomerSelectionFilter: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const filter = useAppSelector<CustomerFilter>((state: RootState) => state.data.customerFilter)
  const companies = useAppSelector((state: RootState): AdminCompany[] => state.admin.companies)

  useEffect(() => {
    dispatch(FetchCompaniesAction())
  }, [dispatch])

  const handleChange = (newFilter: CustomerFilter): void => {
    dispatch(CustomerFilterChangedAction(newFilter))
    dispatch(SetMeterActivePageAction({ activePage: 1 }))
  }

  return (
        <StyledFormControl variant="outlined" size="small">
            <InputLabel>{t('customer_filter')}</InputLabel>
            <Select value={customerFilterToString(filter)} onChange={(e) => {
              handleChange(customerFilterFromString(e.target.value))
            }} label={t('customer_filter')}>
                <MenuItem value="all">{t('all')}</MenuItem>
                {companies.map(item => (
                    <MenuItem value={item.id} key={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
  )
}

/* Helper Functions */

function customerFilterToString(filter: CustomerFilter): string {
  if (filter.type === CustomerFilterType.All) {
    return 'all'
  } else {
    return filter.companyId
  }
}

function customerFilterFromString(value: string): CustomerFilter {
  if (value === 'all') {
    return {
      type: CustomerFilterType.All
    }
  }

  return {
    type: CustomerFilterType.ById,
    companyId: value
  }
}
